<template>
  <AdStatusDot
    :icon="matchingIcon"
    :status="statusCode"
    class="pr-1"
    larger
  />
</template>

<script>
export default {
  props: {
    activeItem: {
      type: Object,
      required: false,
      default: () => ({})
    },
    artefact: {
      type: String,
      required: false,
      default: ''
    },
    open: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    matchingIcon () {
      if (this.artefact === 'DS') {
        /*
          DS dataset Nav Tree icons.
        */
        if (this.activeItem?.type === 'group') {
          if (this.activeItem?.inherit) {
            return this.open === true ? 'mdi-folder-open-outline' : 'mdi-folder-outline'
          } else {
            return this.open === true ? 'mdi-folder-open' : 'mdi-folder'
          }
        } else return 'mdi-book-open-blank-variant'
      } else if (this.artefact === 'DE') {
        /*
          DE dataset concept Nav Tree icons.
        */
        if (this.activeItem?.inheritedContains) {
          return 'mdi-share-all-outline'
        } else if (this.activeItem?.contains) {
          return 'mdi-share-all'
        } else if (this.activeItem?.recycle) {
          return this.recyclebinempty ? 'mdi-trash-can-outline' : 'mdi-trash-can'
        } else if (this.activeItem?.type === 'group') {
          if (this.activeItem?.inherit) {
            return this.open === true ? 'mdi-folder-open-outline' : 'mdi-folder-outline'
          } else {
            return this.open === true ? 'mdi-folder-open' : 'mdi-folder'
          }
        } else if (this.activeItem?.ref) {
          return 'mdi-link-variant'
        } else if (this.activeItem?.inherit) {
          return 'mdi-link-variant'
        } else return 'mdi-cube' // mdi-checkbox-blank-circle
      } else if (this.artefact === 'TM') {
        /*
          TM template Nav Tree icons.
        */
        if (this.activeItem?.displayName) {
          if (this.activeItem?.ref) {
            /* this item is a reference */
            return 'mdi-link-variant'
          } else if (this.activeItem?.version?.[0].representingTemplate) {
            return 'mdi-inbox-full'
          } else {
            return 'mdi-recycle'
          }
        } else {
          /* this item is a template grouping item */
          return this.open === true ? 'mdi-folder-open' : 'mdi-folder'
        }
      } else if (this.artefact === 'TI') {
        if (this.activeItem.is === 'element') return 'mdi-cube'
        if (this.activeItem.is === 'attribute') return 'mdi-form-textbox'
        if (this.activeItem.is === 'choice') return 'mdi-arrow-decision'
        if (this.activeItem.is === 'let') return 'mdi-microphone'
        if (this.activeItem.is === 'defineVariable') return 'mdi-eyedropper'
        if (this.activeItem.is === 'assert') return 'mdi-thumb-up'
        if (this.activeItem.is === 'report') return 'mdi-thumb-up-outline'
        if (this.activeItem.is === 'include') return 'mdi-tray-full'
        if (this.activeItem.is === 'item') return ''
        if (this.activeItem.is === 'constraint') return ''
        if (this.activeItem.is === 'property') return ''
        if (this.activeItem.is === 'text') return 'mdi-text-short'
        return 'mdi-radiobox-blank'
      } else if (this.artefact === 'SC') {
        /*
          SC scenario Nav Tree icons.
        */
        if (this.activeItem?.type === 'initial') {
          /* this is a scenario */
          return 'mdi-arrow-right-bold'
        } else if (this.activeItem?.type === 'back') {
          /* this is a scenario */
          return 'mdi-arrow-left-bold'
        } else if (this.activeItem?.type === 'stationary') {
          /* this is a scenario */
          return 'mdi-file-document'
        } else if (this.activeItem?.type === 'group') {
          return this.open === true ? 'mdi-folder-open' : 'mdi-folder'
        } else return 'mdi-movie'
      } else if (this.artefact === 'VS' || this.artefact === 'CS') {
        if (this.activeItem?.ref) {
          return 'mdi-link-variant'
        }
      } else if (this.artefact === 'QQ') {
        /*
          QQ questionnaire Nav Tree icons.
        */
        if (this.activeItem?.linkId) {
          // Questionnaire body items
          if (this.activeItem.type === 'group') return 'mdi-folder'
          if (this.activeItem.type === 'display') return 'mdi-tag-text-outline'
          return this.$filters.getValueDomainTypeIcon(this.activeItem.type)
        }
        // Questionnaire items
        if (this.activeItem?.enhanced === 'true') return 'mdi-comment-edit' /* this is an enhanced questionnaire  */
        if (this.$filters.isQuestionnaireResponse(this.activeItem)) return 'mdi-comment-check' /* this is a questionnaire response */
        return 'mdi-comment-question'
      } else if (this.artefact === 'IG') {
        if (this.activeItem?.indexpage) {
          return 'mdi-anchor'
        } else return undefined
      } else if (this.artefact === 'CM') {
        return 'mdi-map-marker'
      } else return undefined
      /*
      if (item?.displayName) {
        // this is a dataset, a value set or a template/profile
        return item?.[this.activeItemKey] ? 'mdi-checkbox-blank-circle' : 'mdi-link-variant'
      }
      */

      return undefined
    },

    statusCode () {
      if (this.activeItem?.recycle) return 'cancelled'
      return this.activeItem?.statusCode
    },

    recyclebinempty () {
      if (this.activeItem?.recycle) {
        if (this.activeItem?.concept?.[0]) {
          if (this.activeItem?.concept[0].navkey) return false
          else return true
        }
      }
      return true
    }
  }
}
</script>
